/**
 * Add new elements and callback-methods through the loader's watch method. If an element is in the viewport (either
 * on load or later reached on scroll) the provided callback method will be executed
 */

let listenerCallback

/**
 */
export class Loader {

    constructor() {
        this.registeredNodes = []
        this.watchedElements = [];
        this.identifiers = new Map()
        this.isRunning = false
    }

    /**
     * @param selector - Javascript selector, eg '.classname'
     * @param _cb - Callback Function to call when conditions are reached
     * @param func - Window selector function to apply on 'selector'
     * @param distanceToTop - If is numeric, callback will be called when the top of the element has X distance to the
     * top of the window
     * @param onTotalScroll - If is numeric, callback will be called when the total window scroll is bigger than number
     * @param viewportOffset - If not distance to top / ontotalscroll, additional buffer that will allow the import to
     * run before the element is in the viewport. Default: 20px before the element is reached callback will be executed
     * @param underScreenWidth - JS will only be loaded if window.innerWidth <=  underScreenWidth
     * @param afterScreenWidth - JS will only be loaded if window.innerWidth >=  afterScreenWidth
     * @param onceForAllNodes - IF "func = querySelectorAll" and onceForAllNodes = true => Callback will be called once
     * and then all other watched elements for this node will be removed
     */
    watch({selector, _cb, func = 'querySelectorAll', distanceToTop = undefined, onTotalScroll = undefined, viewportOffset = 20, underScreenWidth = undefined, afterScreenWidth = undefined, onceForAllNodes = true}) {
        if(onTotalScroll !== undefined || underScreenWidth !== undefined || afterScreenWidth !== undefined  ) {
            this._registerSingleHandler({onTotalScroll: onTotalScroll, underScreenWidth: underScreenWidth, afterScreenWidth: afterScreenWidth,_cb: _cb})
        } else if (['querySelectorAll', 'getElementsByTagName'].includes(func)) {
            const id = this._generateIdentifier()
            Array.from(document[func](selector)).forEach(singleNode => this._registerSingleHandler({selector: selector, id: id, onceForAllNodes: onceForAllNodes, node: singleNode, _cb: _cb, distanceToTop: distanceToTop, viewportOffset: viewportOffset }))
        } else {
            const n = document[func](selector);
            if(n) {
                this._registerSingleHandler({selector: selector, node: n, _cb: _cb, distanceToTop: distanceToTop, viewportOffset: viewportOffset})
            }
        }
    }

    /**
     * Generate random unique identifier
     *
     * @returns {number}
     * @private
     */
    _generateIdentifier() {
        let rand = Math.ceil(Math.random() * 10000);
        while(this.identifiers.get(rand)) {
            rand = Math.ceil(Math.random() * 10000);
        }
        this.identifiers.set(rand, true);
        return rand;
    }

    /**
     * Start the loader => Attach events listeners and check all nodes
     */
    run() {
        if(!this.isRunning) {
            setTimeout(this._executeLoop.bind(this), 500)
            listenerCallback = this._executeLoop.bind(this)
            document.addEventListener('scroll-throttled', listenerCallback);
            document.addEventListener('resize-throttled', listenerCallback);
        }
        this.isRunning = true
    }

    /**
     * Initially called method for single registered elements. If conditions meet on pageload => run callback, else
     * add to watched elements
     * 
     * @param e
     * @private
     */
    _registerSingleHandler(e) {
        if(this._isElementReadyForCallback(e)) {
            e._cb(e.node)
        } else {
            this.watchedElements.push(e)
        }
    }

    /**
     * Check if run-conditions are met for given object
     *
     * @param e
     * @returns {boolean|*}
     * @private
     */
    _isElementReadyForCallback(e) {
        if(e.onTotalScroll !== undefined) {
            return window.scrollY >= e.onTotalScroll;
        } else if (e.distanceToTop !== undefined) {
            return window.scrollY >= (e.node.offsetTop - e.distanceToTop);
        } else if(e.underScreenWidth !== undefined) {
            return window.innerWidth < e.underScreenWidth;
        } else if(e.afterScreenWidth !== undefined) {
            return window.innerWidth > e.afterScreenWidth;
        } else if (e.node) {
            return e.node.isInViewport(e.viewportOffset)
        }
        return false;
    }

    /**
     * Listener-loop attached to scroll and resize events
     *
     * Todo: Make more sexy
     *
     * @private
     */
    _executeLoop() {
        const identifiersForAll = []

        this.watchedElements = this.watchedElements.filter(e => {

            if(this._isElementReadyForCallback(e)) {
                e._cb(e.node)
                if(e.isDone && e.id && e.onceForAllNodes) {
                    identifiersForAll.push(e.id)
                }
                return false;
            }

            return true;

        });

        if(identifiersForAll.length > 0) {
            this.watchedElements = this.watchedElements.filter(e => !(e.id && identifiersForAll.includes(e.id)))
        }

        if(this.watchedElements.length === 0) {
            document.removeEventListener('scroll-throttled', listenerCallback);
            document.removeEventListener('resize-throttled', listenerCallback);
        }
    }
}